"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialFormValues = void 0;
const initialFormValues = exports.initialFormValues = {
    textAreaFieldInput1: '',
    textAreaFieldInput2: '',
    textAreaFieldInput3: '',
    radioButtonFieldInput4: '',
    radioButtonFieldInput5: '',
    radioButtonFieldInput6: '',
    textFieldInput7: '',
    textAreaFieldInput9: '',
    recaptcha: ''
};
